// extracted by mini-css-extract-plugin
module.exports = {"container":"KeywordBadge_container__xVf8Q"};